// extracted by mini-css-extract-plugin
module.exports = {"styledList":"BreakdownCard_styledList__BrVbK"};